var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex items-center" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "flex-1" }, [
        _vm.booking.invoice
          ? _c("div", [
              _c("h3", [_vm._v("Your Invoice")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm._f("date")(_vm.booking.invoice.created_at))),
              ]),
            ])
          : _c("div", { staticClass: "flex flex-col" }, [
              _c("h3", [_vm._v("Your invoice will appear here")]),
              _vm._v(" "),
              _c("span", [
                _vm._v("Your invoice will appear here 1-2 days after booking"),
              ]),
            ]),
      ]),
      _vm._v(" "),
      _vm.booking.invoice
        ? _c(
            "ladda-button",
            {
              staticClass: "btn btn-primary btn-sm",
              attrs: { type: "submit", click: _vm.viewInvoice },
            },
            [_vm._v("\n    View Invoice\n  ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "flex items-center justify-center margin-r-2",
        staticStyle: {
          height: "35px",
          width: "35px",
          "border-radius": "100%",
          "background-color": "#e3e3e3",
        },
      },
      [_c("i", { staticClass: "fa fa-file-invoice" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }